import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Title from '../components/Title/Title';
import LinkedList from '../components/LinkedList/LinkedList';

const Info = () => {
  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-12 col-md-5">
          <Title weight="400">PRODUCT CREATOR <br/> LONDON, UK </Title>
          <LinkedList
            items={[
              {
                label: "EMAIL: CONTACT@STEVENROBERTS.INFO",
                to: "mailto:contact@stevenroberts.info",
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default Info;
